import { apiClient } from "../../../base/ApiClient";

export const getClientObservations = async (clientId) => {
  const response = await apiClient.get(`/client/${clientId}/care-observations/`);
  return response.data;
};

export const updateClientObservations = async (clientId, observationData) => {
  const response = await apiClient.patch(`/client/${clientId}/care-observations/`, observationData);
  return response.data;
};